import { render, staticRenderFns } from "./Hairdressing.vue?vue&type=template&id=e02adf6a&scoped=true&"
import script from "./Hairdressing.vue?vue&type=script&lang=js&"
export * from "./Hairdressing.vue?vue&type=script&lang=js&"
import style0 from "./Hairdressing.vue?vue&type=style&index=0&id=e02adf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02adf6a",
  null
  
)

export default component.exports